export default __webpack_public_path__ + "static/media/C0004.2763c163.png";